const router = [
  {
    path: '/consultations_list',
    name: 'OverseasConsultationFormList',
    component: () => import('@/views/PurchaseManagement/OverseasConsultationForm/List.vue'),
    meta: {
      title: '海外咨询单 列表'
    }
  },
  {
    path: '/push_9010',
    name: 'OverseasConsultationFormPush9010',
    component: () => import('@/views/PurchaseManagement/OverseasConsultationForm/Push.vue'),
    meta: {
      title: '海外咨询单 提醒'
    }
  }
];
export default router;
